import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from "@mui/material/Paper";
import Icn from "../Icn";
import {register, unregister} from "../../domain/socketSlice";
import {api} from "../../maps/data.js";
import WeightGraph from "../WeightGraph";

const WrapperStyled = styled.div`
    height: 100%;
    margin: 10px;
    position: relative;
`;

const SensorBoxStyled = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;


const DataStyled = styled.div`
    display: grid;
    grid-template-columns: 160px 170px 180px;
    margin-bottom: 10px;
`;

const DataItemStyled = styled.div`
    .label {
        margin-right: 5px;
        color: #6c7987;
    }

    .value {

    }
`;


const SensorWeightDialog = ({sensor, onClose, siteId, edgeId}) => {
    const ref = useRef(null);

    const [sensorData, s_sensorData] = useState([]);
    const [currentTotal, s_currentTotal] = useState(0);
    const [lastTotal, s_lastTotal] = useState(0);
    const [currentDelta, s_currentDelta] = useState(0);

    const [height, s_height] = useState(0);
    const [width, s_width] = useState(0);
    const sensorId = sensor.sensorId;
    const eventName = `test-sensor`;

    useEffect(() => {
        register(eventName);
        window.addEventListener(eventName, onData);


        return () => {
            unregister(eventName);
            window.removeEventListener(eventName, onData);
        };
    }, []);

    useEffect(() => {
        api({
            type: 'testSensor', data: {
                siteId,
                sensorId,
                edgeId,
                enabled: true,
                type: 'weight'
            }
        });

        return () => {
            api({
                type: 'testSensor', data: {
                    siteId,
                    sensorId,
                    edgeId,
                    enabled: false
                }
            });
        };
    }, []);

    useEffect(() => {
        if (ref.current && ref.current.offsetWidth) {
            s_height(ref.current.offsetHeight);
            s_width(ref.current.offsetWidth);
        }
    }, [ref.current]);

    const onData = async (sensorData) => {
        const data = sensorData.detail;

        if (data) {
            s_currentTotal(data.totalWeight);
            s_currentDelta(data.deltaWeight);

            s_lastTotal(prevState => {
                if (prevState - 5 > data.totalWeight || prevState + 5 < data.totalWeight) {
                    return data.totalWeight;
                }
                return prevState;
            });

            if (data.deltaWeight) {
                s_sensorData(prevState => {
                    data.time = Date.now();
                    const copyOfPrevState = [...prevState];
                    if (copyOfPrevState.length === 30) {
                        return [...copyOfPrevState.slice(1), data];
                    } else {
                        return [...copyOfPrevState, data];
                    }
                });
            }
        }
    };

    const sensorWidth = sensor.sensor.width / 0.8;
    const sensorHeight = sensor.sensor.height / 0.8;

    let divider = width / sensorWidth;
    if (sensorHeight > sensorWidth) {
        divider = height / sensorHeight;
    }

    let boxWidth = 0;
    let boxHeight = 0;
    if (sensorWidth > sensorHeight) {
        boxWidth = "95%";
        boxHeight = sensorHeight * divider;
    } else {
        boxHeight = '100%';
        boxWidth = sensorWidth * divider;
    }

    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullScreen={true}>

            <DialogTitle id="alert-dialog-title">
                <Icn style={{position: 'relative', top: 4}}>scienceIcon</Icn> Weight test[{sensor?.sensor?.boardId}]
                - {sensor?.sensorId}, MAC: {sensor?.sensor?.mac}
            </DialogTitle>
            <DialogContent>
                <DataStyled>
                    <DataItemStyled>
                        <span className="label">Current delta:</span>
                        <span className="value">{currentDelta}</span>
                    </DataItemStyled>
                    <DataItemStyled>
                        <span className="label">Current total:</span>
                        <span className="value">{currentTotal}</span>
                    </DataItemStyled>
                    <DataItemStyled>
                        <span className="label">Last valued total:</span>
                        <span className="value">{lastTotal}</span>
                    </DataItemStyled>
                </DataStyled>
                <WrapperStyled ref={ref} style={{height: boxHeight, width: boxWidth, margin: 0, padding: 0}}>
                    <SensorBoxStyled>
                        <Paper elevation={3} style={{height: "100%"}}>
                            {!!sensorData?.length && (
                                <WeightGraph
                                    data={sensorData}
                                />
                            )}
                        </Paper>
                    </SensorBoxStyled>
                </WrapperStyled>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SensorWeightDialog;